import { ClientTelerikReportPage } from "../components/ClientTelerikReportPage";
import { CLIENTS_ALL_ROLES } from "../../SharedModule/utils/constants";

export const ClientRelationshipReviewReportPage = () => (
  <ClientTelerikReportPage
    documentTitle="The Hub - Relationship Review Report"
    reportTitle="Relationship Review Report"
    reportName="ClientsRelationshipsReview.trdp"
    allowedRoles={CLIENTS_ALL_ROLES}
    parametersAreaVisible={false}
  />
);
